import {Space} from "antd";
import {CustomerServiceOrderListEmptyState} from "./empty-state";
import {CustomerServiceOrderListView} from "./list";
import {
  useGetCustomerStoreServicesOrdersContext,
  GetCustomerStoreServicesOrdersContextProvider,
} from "../../../../../../service-feature/useCases/get-orders/context/customer";

export function CustomerServiceOrderList() {
  const {isLoading, isPreviousData, orders} = useGetCustomerStoreServicesOrdersContext();
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {isPreviousData && <p>Loading next page… (previous data shown)</p>}
      {isLoading && <p>Loading orders...</p>}
      {!isLoading && orders.length > 0 ? (
        // <GetCustomerStoreServicesOrdersContextProvider>
        <CustomerServiceOrderListView />
      ) : (
        // </GetCustomerStoreServicesOrdersContextProvider>
        <CustomerServiceOrderListEmptyState />
      )}
    </Space>
  );
}
